import { createFileRoute, Outlet, redirect } from '@tanstack/react-router'

import sideMiniImage from '~in-app/assets/side-mini.png'
import { ThemeButton } from '~in-app/components'
import { auth$, route$ } from '~in-app/legend-state'
export const Route = createFileRoute('/(public)/_public')({

  beforeLoad: () => {
    if (auth$.jwt.get()) {
      return redirect({ to: route$.fallbackPath('auth') })
    }
  },
  component: PublicLayout,
  staticData: {
    privileges: [],
  },
})

function PublicLayout() {
  return (
    <>
      {/* eslint-disable-next-line tailwindcss/no-contradicting-classname */}
      <div className="absolute inset-0 bg-[linear-gradient(to_right,#4f4f4f2e_1px,transparent_1px),linear-gradient(to_bottom,#4f4f4f2e_1px,transparent_1px)] bg-[size:14px_24px] [mask-image:radial-gradient(ellipse_80%_50%_at_50%_0%,#000_70%,transparent_110%)]" />

      <div className="container mx-auto flex h-screen flex-col items-center justify-center">
        <div className="container absolute top-0 mx-auto flex w-full items-center justify-between">
          <div className="flex items-center justify-center gap-2 py-4 text-3xl">
            <img
              alt="Sidebar Mini"
              className="mb-2"
              height="50px"
              src={sideMiniImage}
              width="50px"
            />

            <span className="text-3xl">PLM</span>
          </div>

          <ThemeButton />
        </div>

        <Outlet />
      </div>

    </>
  )
}
